/**
 * TanStack Query hooks for `campaign-status-filter`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignStatusFilterQueryKeys,
	type CreateCampaignStatusFilterBody,
	type ListCampaignStatusFilterResponse,
	type CampaignStatusFilterRow,
} from "./api";

export function useCampaignStatusFilterList(): UseQueryResult<ListCampaignStatusFilterResponse, Error> {
	return useQuery({
		queryKey: campaignStatusFilterQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignStatusFilterCreate(): UseMutationResult<CampaignStatusFilterRow, Error, CreateCampaignStatusFilterBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignStatusFilterQueryKeys.all });
		},
	});
}

export function useCampaignStatusFilterDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignStatusFilterQueryKeys.all });
		},
	});
}
